var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCloseWhiteX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nav_close",
    d: "M13.423 11.1603L21.6485 2.93444C21.8748 2.708 21.9996 2.40591 22 2.08377C22 1.76147 21.8752 1.45901 21.6485 1.23293L20.9277 0.512295C20.7011 0.28532 20.399 0.161011 20.0765 0.161011C19.7546 0.161011 19.4525 0.28532 19.2259 0.512295L11.0004 8.73761L2.7745 0.512295C2.54824 0.28532 2.24597 0.161011 1.92366 0.161011C1.60171 0.161011 1.29943 0.28532 1.07317 0.512295L0.352 1.23293C-0.117333 1.70226 -0.117333 2.46564 0.352 2.93444L8.57767 11.1603L0.352 19.3858C0.125561 19.6126 0.000894309 19.9147 0.000894309 20.2368C0.000894309 20.5589 0.125561 20.861 0.352 21.0877L1.07299 21.8083C1.29925 22.0351 1.60171 22.1596 1.92348 22.1596C2.24579 22.1596 2.54806 22.0351 2.77433 21.8083L11.0002 13.5828L19.2257 21.8083C19.4523 22.0351 19.7544 22.1596 20.0763 22.1596H20.0767C20.3988 22.1596 20.7009 22.0351 20.9275 21.8083L21.6484 21.0877C21.8746 20.8612 21.9995 20.5589 21.9995 20.2368C21.9995 19.9147 21.8746 19.6126 21.6484 19.386L13.423 11.1603Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCloseWhiteX);
export default __webpack_public_path__ + "static/media/nav_close_white_x.157579e5b44cd34b681b3db3812f5250.svg";
export { ForwardRef as ReactComponent };